import {matchesMenuPath} from '@components/Navigation/utils.js'

export const MENU_STATES = Object.freeze({
  ACTIVE: 'active',
  LOCKED: 'locked',
  HIDDEN: 'hidden',
})

export const FALLBACK_ACTIVE_MENU_KEYS = Object.freeze([
  'notifications',
  'accounts',
  'account-list',
  'obligations',
  'invite-friend',
  'settings',
  'subscribe',
  'settings-billing-history',
  'setup-profile',
  'settings-passkeys',
  'settings-support-help',
  'settings-activity-log',
  'settings-delete-account',
  'logout',
])

export const FALLBACK_ALLOWED_ROUTE_PREFIXES = Object.freeze([
  '/',
  '/notifications',
  '/account-list',
  '/obligations',
  '/invite-friend',
  '/setup-profile',
  '/subscribe',
  '/forecast-summary',
  '/settings/billing-history',
  '/settings/passkeys',
  '/settings/finance-analysis-history',
  '/settings/support-help',
  '/settings/activity-log',
  '/settings/delete-account',
  '/terms',
  '/privacy',
  '/about',
  '/refund',
])

export const FALLBACK_ACTIVE_MENU_KEY_SET = new Set(FALLBACK_ACTIVE_MENU_KEYS)

export const menuSnapshotToMap = (menu = []) => {
  const map = new Map()

  if (!Array.isArray(menu)) {
    return map
  }

  for (const entry of menu) {
    if (!entry || typeof entry.key !== 'string') continue
    const state = typeof entry.state === 'string' ? entry.state : MENU_STATES.HIDDEN
    map.set(entry.key, {
      key: entry.key,
      state,
      reason: typeof entry.reason === 'string' ? entry.reason : '',
    })
  }

  return map
}

export const isPathAllowed = (pathname, allowedPrefixes = []) => {
  if (!Array.isArray(allowedPrefixes) || allowedPrefixes.length === 0) {
    return false
  }

  return allowedPrefixes.some((candidate) => {
    if (candidate === '/') {
      return pathname === '/'
    }
    return matchesMenuPath(pathname, candidate)
  })
}
